// extracted by mini-css-extract-plugin
export default {"menuContainer":"HeaderMenu_menuContainer__PHLDm"};